export enum ReservationStatusEnum {
  unconfirmed = 'unconfirmed',
  confirmed = 'confirmed',
  completed = 'completed',
  inProgress = 'in_progress',
  canceled = 'canceled'
}
